import { Check, X, Phone } from "lucide-react";
import logo from "@/assets/oz-clean-logo.png";

const rows = [
  { feature: "Fixed Transparent Pricing", description: "Know exactly what you're paying before the job starts." },
  { feature: "Satisfaction Guarantee", description: "We're not happy unless you're happy." },
  { feature: "Fully Insured", description: "Complete peace of mind on every job." },
  { feature: "Professional Equipment", description: "Commercial-grade tools and eco products." },
  { feature: "Flexible Scheduling", description: "Times that work around your life." },
  { feature: "Fast Response Times", description: "Quick quotes and quick bookings." },
  { feature: "Reliable Team", description: "Friendly local cleaners who actually turn up." },
];

const ComparisonSection = () => (
  <section id="comparison" className="bg-[#f7f7f7] py-20 md:py-28">
    <div className="container max-w-4xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#111111] text-center mb-14 leading-tight">
        Why More People Are Choosing
        <br />
        <span className="text-[#111111]">OZ CLEAN CO.</span>
      </h2>

      <div className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-end gap-0 mb-0">
        <div />
        <div className="bg-[#FFD400] rounded-t-2xl py-4 text-center shadow-[0_-4px_16px_rgba(255,212,0,0.25)] flex flex-col items-center justify-center">
          <img src={logo} alt="OZ CLEAN CO." className="h-14 md:h-16 w-auto" width="384" height="256" />
        </div>
        <div className="py-5 text-center">
          <span className="text-[#111111]/70 font-bold text-xs md:text-sm">
            Others
          </span>
        </div>
      </div>

      <div>
        {rows.map((row, i) => (
          <div
            key={row.feature}
            className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-center gap-0 border-b border-[#111111]/8 last:border-b-0"
          >
            <div className="py-6 pr-4">
              <p className="font-extrabold text-[#111111] text-sm md:text-base leading-snug">
                {row.feature}
              </p>
              <p className="text-[#111111]/70 text-xs md:text-sm mt-1 leading-snug">
                {row.description}
              </p>
            </div>

            <div
              className={`bg-[#FFD400] flex items-center justify-center py-6 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.05)] ${
                i === rows.length - 1 ? "rounded-b-2xl shadow-[0_4px_16px_rgba(255,212,0,0.2),inset_0_0_0_1px_rgba(0,0,0,0.05)]" : ""
              }`}
            >
              <div className="w-8 h-8 rounded-full bg-[#111111]/10 flex items-center justify-center">
                <Check className="w-4 h-4 text-[#111111]" strokeWidth={3} />
              </div>
            </div>

            <div className="flex items-center justify-center py-6">
              <div className="w-8 h-8 rounded-full bg-[#111111]/[0.04] flex items-center justify-center">
                <X className="w-4 h-4 text-[#111111]/25" strokeWidth={2.5} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 text-center">
        <h3 className="text-2xl md:text-3xl font-black text-[#111111] mb-3">
          Ready for a sparkling clean?
        </h3>
        <p className="text-[#111111]/70 text-sm mb-8">
          Fast quotes and reliable scheduling.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#quote"
            className="bg-[#0066FF] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-[#0066FF]/90 transition-colors text-center shadow-[0_4px_14px_rgba(0,102,255,0.3)]"
          >
            Get Free Quote
          </a>
          <a
            href="tel:1300000000"
            className="flex items-center justify-center gap-2 border-2 border-[#111111] text-[#111111] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#111111]/5 transition-colors text-center"
          >
            <Phone className="w-5 h-5" />
            Call Now
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ComparisonSection;
